import { useMutation, useQuery, useQueryClient } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useGettingStartedSteps = (config) => {
  return useQuery({
    ...config,
    queryKey: "getting-started-steps",
    queryFn: () =>
      fetch({
        url: `${Angie.api_url}/getting-started`,
      }),
  });
};

export const useCompleteStepMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (step) =>
      fetch({
        url: `${Angie.api_url}/getting-started`,
        method: "PUT",
        body: { step },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(["getting-started-steps"]);
    },
  });
};

export const useClaimRewardMutation = () => {
  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/getting-started`,
        method: "POST",
      }),
  });
};

export const useSetCelebrationShownMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/getting-started-celebration`,
        method: "POST",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(["getting-started-steps"]);
    },
  });
};
